import { useState, useEffect } from 'react';
import { documentsService } from '../services/api';
import logo from '../assets/logo.png';
import './Documents.css';

function Documents({ user, onLogout }) {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    loadDocuments();
  }, []);

  const loadDocuments = async () => {
    try {
      const docs = await documentsService.listDocuments();
      setDocuments(docs);
    } catch (err) {
      setError('Erro ao carregar documentos');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (doc) => {
    setDownloading(doc.id);
    setError('');
    
    try {
      const blob = await documentsService.downloadDocument(doc.id);
      
      // Criar URL temporária e fazer download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = doc.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError('Erro ao baixar documento. Tente novamente.');
    } finally {
      setDownloading(null);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    onLogout();
  };

  return (
    <div className="documents-container">
      <header className="documents-header">
        <div className="header-content">
          <div className="header-left">
            <div className="header-logo">
              <img src={logo} alt="Fortaleza EC" />
            </div>
            <div className="header-title">
              <h1>FORTALEZA EC</h1>
              <p>Portal de Documentos</p>
            </div>
          </div>
          
          <div className="header-right">
            <div className="user-info">
              <span className="user-name">{user.nome}</span>
              <span className="user-cpf">{user.email}</span>
              <span className="user-cpf">CPF: {user.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')}</span>
            </div>
            <button onClick={handleLogout} className="logout-button">
              Sair
            </button>
          </div>
        </div>
      </header>

      <main className="documents-main">
        <div className="documents-content">
          <h2 className="section-title">Documentos Disponíveis</h2>
          
          {error && <div className="error-banner">{error}</div>}
          
          {loading ? (
            <div className="loading">
              <div className="spinner"></div>
              <p>Carregando documentos...</p>
            </div>
          ) : (
            <div className="documents-grid">
              {documents.map((doc) => (
                <div key={doc.id} className="document-card">
                  <div className="document-icon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#003366" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M14 2V8H20" stroke="#003366" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M16 13H8" stroke="#e30613" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M16 17H8" stroke="#e30613" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M10 9H9H8" stroke="#e30613" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  
                  <div className="document-info">
                    <h3>{doc.name}</h3>
                    <p>{doc.description}</p>
                  </div>
                  
                  <button
                    onClick={() => handleDownload(doc)}
                    disabled={downloading === doc.id}
                    className="download-button"
                  >
                    {downloading === doc.id ? (
                      <>
                        <span className="button-spinner"></span>
                        Baixando...
                      </>
                    ) : (
                      <>
                        <span className="download-icon">⬇</span>
                        Baixar PDF
                      </>
                    )}
                  </button>
                  
                  <div className="watermark-info">
                    <small>
                      Este documento será marcado com seus dados de acesso
                    </small>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>

      <footer className="documents-footer">
        <p>© 2026 Fortaleza Esporte Clube - Todos os direitos reservados</p>
        <p>Portal seguro e protegido</p>
      </footer>
    </div>
  );
}

export default Documents;
